function getShortAddress(address?: string) {
  if (!address) {
    return '';
  }

  if (address.length < 13) return address;

  if (address.includes('.') && address.length > 13)
    return `${address.slice(0, 10)}...`;

  return `${address.slice(0, 6)}...${address.slice(-4)}`;
}

export default getShortAddress;
